:host {
  @apply block;
}

:host([last]) {
  .pk-sequence--item__body {
    &.empty {
      @apply m-0 p-0;

      min-height: unset;
    }
  }
}

.pk-sequence--item__line {
  @apply absolute left-[calc(calc(var(--sequence-item--marker-width)_+_var(--sequence-item--stroke))_*_0.5)] h-full w-[--sequence-item--stroke] bg-[color:--sequence-item--accent-color];
}

.pk-sequence--item__line.stepper {
  &.default,
  &.active {
    @apply bg-[color:--sequence-stepper--default-ui-color];
  }

  &.done {
    @apply bg-[color:--sequence-stepper--active-ui-color];
  }
}

.pk-sequence--item__mark {
  @apply flex h-[--sequence-item--marker-height] w-[--sequence-item--marker-width] items-center justify-center bg-[color:--sequence-item--marker-background];
  @apply rounded-full border-[length:--sequence-item--stroke] border-solid border-[color:--sequence-item--accent-color];

  &.sequence {
    @apply bg-[color:--sequence-item--accent-color];
  }

  ::slotted(pk-icon[slot='mark']) {
    @apply [--icon--color:--sequence-item--accent-color];
  }

  ::slotted(span[slot='mark']) {
    @apply font-regular text-l leading-l text-[color:--sequence-item--marker-text-color];
  }
}

.pk-sequence--item__mark.stepper {
  &.default {
    @apply border-[color:--sequence-stepper--default-ui-color] bg-[color:--sequence-stepper--default-marker-background];

    ::slotted(span[slot='mark']) {
      @apply text-[color:--sequence-stepper--default-marker-text-color];
    }
  }

  &.active,
  &.done {
    @apply border-[color:--sequence-stepper--active-marker-background] bg-[color:--sequence-stepper--active-marker-background];

    ::slotted(span[slot='mark']) {
      @apply text-[color:--sequence-stepper--active-marker-text-color];
    }
  }
}

.pk-sequence--item__title {
  ::slotted(*) {
    @apply m-0 p-0 font-semibold text-l leading-l text-[color:--sequence-item--title-color];
  }
}

.pk-sequence--item__title.stepper {
  &.default {
    ::slotted(*) {
      @apply text-[color:--sequence-stepper--default-title-color];
    }
  }

  &.active,
  &.done {
    ::slotted(*) {
      @apply text-[color:--sequence-stepper--active-title-color];
    }
  }
}

.pk-sequence--item__body {
  ::slotted(*) {
    @apply m-0 p-0 font-regular text-l leading-l text-[color:--sequence-item--body-color];
  }
}

.hidden {
  @include hidden;
}
